var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body p-0" },
      [
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.loading == "table" ? [] : _vm.items.data,
              "show-expand": "",
              "single-expand": true,
              expanded: _vm.expanded,
              options: _vm.options,
              "server-items-length": _vm.items.subtotal,
              loading: _vm.loading == "table",
              "footer-props": {
                "items-per-page-options": [5, 10, 50, 100],
              },
            },
            on: {
              "update:expanded": function ($event) {
                _vm.expanded = $event
              },
              "update:options": function ($event) {
                _vm.options = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.id",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.type) +
                          _vm._s(item.id) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.tax",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("search-tax", {
                        attrs: { tax: item.tax, childclass: "w-200px" },
                        model: {
                          value: item.tax_id,
                          callback: function ($$v) {
                            _vm.$set(item, "tax_id", $$v)
                          },
                          expression: "item.tax_id",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "item.user",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("search-user", {
                        attrs: { childclass: "w-200px" },
                        on: {
                          set_value: function (e) {
                            return (item.user_id = e)
                          },
                        },
                        model: {
                          value: item.user,
                          callback: function ($$v) {
                            _vm.$set(item, "user", $$v)
                          },
                          expression: "item.user",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "item.value",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.value,
                            expression: "item.value",
                          },
                        ],
                        staticClass: "form-control form-control-sm w-80px",
                        attrs: { type: "text", placeholder: "0.00" },
                        domProps: { value: item.value },
                        on: {
                          keypress: _vm.DOUBLE,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(item, "value", $event.target.value)
                          },
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "item.weight",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(Number(String(item.weight)).toFixed(2)) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.subtotal",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            item.subtotal
                              ? Number(item.subtotal).toFixed(2)
                              : "0.00"
                          ) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.calculate",
                  fn: function (ref) {
                    var item = ref.item
                    var index = ref.index
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "button",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "btn btn-primary btn-m",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                !item.value || !item.tax_id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.CALCULATE(item)
                                              },
                                            },
                                          },
                                          "button",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass: "bi bi-calculator",
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [_vm._v(" "), _c("small", [_vm._v("Calcular")])]
                      ),
                    ]
                  },
                },
                {
                  key: "item.confirm",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "button",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "btn btn-success btn-h w-80px",
                                            attrs: {
                                              disabled: !item.subtotal,
                                              type: "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.CONFIRM(item)
                                              },
                                            },
                                          },
                                          "button",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass: "fa fa-save",
                                          }),
                                          _vm._v(" +"),
                                          _c("i", {
                                            staticClass: "bi bi-check-lg",
                                          }),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [_vm._v(" "), _c("small", [_vm._v("Confirmar")])]
                      ),
                    ]
                  },
                },
                {
                  key: "expanded-item",
                  fn: function (ref) {
                    var headers = ref.headers
                    var item = ref.item
                    var index = ref.index
                    return [
                      _c("td", { attrs: { colspan: "100%" } }, [
                        _c("div", { staticClass: "container py-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "div",
                                { staticClass: "form-group mb-2" },
                                [
                                  _c("small", { staticClass: "input-title" }, [
                                    _vm._v("Impuesto"),
                                  ]),
                                  _vm._v(" "),
                                  _c("search-tax", {
                                    attrs: { tax: item.tax },
                                    model: {
                                      value: item.tax_id,
                                      callback: function ($$v) {
                                        _vm.$set(item, "tax_id", $$v)
                                      },
                                      expression: "item.tax_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "div",
                                { staticClass: "form-group mb-2" },
                                [
                                  _c("small", { staticClass: "input-title" }, [
                                    _vm._v("Cliente"),
                                  ]),
                                  _vm._v(" "),
                                  _c("search-user", {
                                    on: {
                                      set_value: function (e) {
                                        return (item.user_id = e)
                                      },
                                    },
                                    model: {
                                      value: item.user,
                                      callback: function ($$v) {
                                        _vm.$set(item, "user", $$v)
                                      },
                                      expression: "item.user",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c("div", { staticClass: "form-group mb-2" }, [
                                _c("small", { staticClass: "input-title" }, [
                                  _vm._v("Valor"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "input-group input-group-sm mb-2",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "bi bi-currency-dollar",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.value,
                                          expression: "item.value",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control-sm",
                                      attrs: {
                                        type: "text",
                                        placeholder: "0.00",
                                      },
                                      domProps: { value: item.value },
                                      on: {
                                        keypress: _vm.DOUBLE,
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "value",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-3" }, [
                              _c(
                                "div",
                                { staticClass: "form-group mb-2" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "button",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn btn-primary btn-h w-100",
                                                        attrs: {
                                                          type: "button",
                                                          disabled:
                                                            !item.value ||
                                                            !item.tax_id,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.CALCULATE(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "button",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("small", [
                                                      _c("i", {
                                                        staticClass:
                                                          "bi bi-calculator",
                                                      }),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("small", [_vm._v("Calcular")]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "form-group mb-3" },
                                [
                                  _c("small", { staticClass: "input-title" }, [
                                    _vm._v("Precio"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "input-group input-group-sm mb-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "bi bi-currency-dollar",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: item.subtotal,
                                            expression: "item.subtotal",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        attrs: {
                                          type: "text",
                                          placeholder: "0.00",
                                        },
                                        domProps: { value: item.subtotal },
                                        on: {
                                          keypress: _vm.DOUBLE,
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              item,
                                              "subtotal",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-append" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-success btn-m",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.ADD_LINE(item)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "bi bi-plus",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    item.invoice_items,
                                    function (bill, i) {
                                      return _c(
                                        "div",
                                        { key: i, staticClass: "row mb-2" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group input-group-sm col pl-0",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-prepend",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-group-text",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "bi bi-currency-dollar",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: bill.value,
                                                    expression: "bill.value",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control form-control-sm",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "0.00",
                                                },
                                                domProps: { value: bill.value },
                                                on: {
                                                  keypress: _vm.DOUBLE,
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      bill,
                                                      "value",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group input-group-sm col pr-0",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: bill.description,
                                                    expression:
                                                      "bill.description",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control form-control-sm",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Descripción",
                                                },
                                                domProps: {
                                                  value: bill.description,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      bill,
                                                      "description",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-append",
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-danger btn-m",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.REMOVE(
                                                            item,
                                                            i
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass: "bi bi-x",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "form-group mb-2" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "button",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn btn-success btn-h w-100",
                                                        attrs: {
                                                          disabled:
                                                            !item.subtotal,
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.CONFIRM(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "button",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("span", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-save",
                                                      }),
                                                      _vm._v("+ "),
                                                      _c("i", {
                                                        staticClass:
                                                          "bi bi-check-lg",
                                                      }),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("small", [_vm._v("Confirmar")]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }